module.exports = __webpack_public_path__ + "img/btn1.51542f77.png";